export default __webpack_public_path__ + "static/media/job_benefit_light.8679a8fc.png";